// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bj_dX","cartIcon":"bj_dX","badge":"bj_dY"};